<template>
  <div class="mail-reset container-inner pt-30 pb-50">
    <h5 class="c-text_title">マイページ</h5>
    <div class="tile is-ancestor">
      <div class="tile is-3 is-sidebar is-vertical is-parent">
        <div class="tile is-child"><SidebarMyPage /></div>
      </div>
      <div class="tile is-parent">
        <div class="tile is-child content-padding ">
          <h4 class="mypage-block-title mb-30">メールアドレスの変更</h4>
          <message-area></message-area>
          <div class="columns">
            <div class="column is-half-desktop" style="padding-right: 0px">
              <b-field
                :message="$v.email.$error ? ($v.email.required ? $t('EF2004_Content') : $t('EF2003_Content')) : ''"
                :type="$v.email.$error ? 'is-danger' : ''"
              >
                <b-input v-model="email" :placeholder="placeholder" type="email" expanded @blur="$v.email.$touch" />
              </b-field>
            </div>
            <div class="column is-one-fifth-mobile">
              <a class="button is-primary" @click="changeMail">送信</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false" /></div
></template>
<style lang="scss" src="./mail-reset.scss" scoped>
</style>

<script>
import SidebarMyPage from '@/components/sidebar/sidebar-mypage/sidebar-mypage';
import { validationMixin } from 'vuelidate';
import { email } from 'vuelidate/lib/validators';
import { changeUserEmailAddress } from '../../../../services/profile.service';
import MessageArea from '@/components/common/message-area/message-area.vue';
import messageUtils from '@/utils/mixins/messageUtils';
import required from 'vuelidate/src/validators/required';
import { getUserSession, getCurrentUser, logout } from '../../../../services/user.service';
import ConfirmPopup from '@/components/common/confirm-popup/confirm-popup.vue';

export default {
  name: 'MailReset',
  components: {
    SidebarMyPage,
    'message-area': MessageArea
  },
  mixins: [validationMixin, messageUtils],

  data() {
    return {
      placeholder: 'abc@mail.com',
      email: ''
    };
  },
  validations: {
    email: {
      email,
      required
    }
  },
  async created() {
    if (!getUserSession()) {
      await logout();
      this.$router.push({
        name: 'login',
        params: {
          page_expectations: this.$route.path
        }
      });
    }
  },
  async mounted() {
    this.loading++;
    const user = await getCurrentUser();
    if (user) {
      this.email = user.email;
    }
    this.loading--;
  },
  methods: {
    toLogin() {
      return logout()
        .then(() => {
          return this.$router.push({ name: 'login', params: { page_expectations: this.$route.path } });
        })
        .catch(err => {
          console.log(err);
          this.setErrorMessage({ messageId: 'EF2081_Content' });
        });
    },
    async changeMail() {
      if (this.$v.$error) {
        return;
      }
      this.clearMessage();
      this.loading++;
      const res = await changeUserEmailAddress(null, this.email);
      this.loading--;
      if (res.status) {
        this.setSuccessMessage(res.result);
        this.$dialog.alert({
          message: `元のメールアドレスに変更確認用のメールを送信しました。\n<br\>
          このアカウントは自動的にログアウトされますので、メールを確認後、再ログインしてください。`,
          onConfirm: () => {
            return this.toLogin();
          },
          type: 'is-primary',
          html: true
        });
      } else {
        this.setErrorMessage(res.result);
        if (res.result !== null && res.result.errorCode === 'auth/requires-recent-login') {
          this.$dialog.alert({
            message: '認証失敗しました。再ログインして試してください。',
            onConfirm: () => {
              return this.toLogin();
            },
            type: 'is-primary'
          });
        }
      }
    }
  }
};
</script>
